module.exports = __webpack_public_path__ + "img/problem.7efae6ec.png";